import { render, staticRenderFns } from "./V2CourseEdit.vue?vue&type=template&id=5754a074&scoped=true&"
import script from "./V2CourseEdit.vue?vue&type=script&lang=js&"
export * from "./V2CourseEdit.vue?vue&type=script&lang=js&"
import style0 from "./V2CourseEdit.vue?vue&type=style&index=0&id=5754a074&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5754a074",
  null
  
)

export default component.exports